module.exports = __webpack_public_path__ + "static/img/logo_18.5a76f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_18.png
// module id = gVYN
// module chunks = 1